import { render, staticRenderFns } from "./TiptapToolbarImage.vue?vue&type=template&id=3118245e"
import script from "./TiptapToolbarImage.vue?vue&type=script&setup=true&lang=js"
export * from "./TiptapToolbarImage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports